import React, { useEffect, useState } from "react";

import { BigPicture, Common } from "../../../helper";

import "../../../assets/stlyes/BigPicture/PPR.scss";

import ClassHomeMathsCheckBox from "../../../assets/images/ClassHomeMathsCheckBox.svg";
import ClassHomeReadingCheckBox from "../../../assets/images/ClassHomeReadingCheckBox.svg";
import ClassHomeWritingCheckBox from "../../../assets/images/ClassHomeWritingCheckBox.svg";
import GroupSubList from "../../../assets/images/GroupSubList.svg";
import NPReading from "../../../assets/images/NPReading.svg";
import NPWriting from "../../../assets/images/NPWriting.svg";
import NPMaths from "../../../assets/images/NPMaths.svg";

const PPRMainTable = (props) => {
  const { setStudentDetails, listView, subject } = props;
  const [fixedHeaders, setFixedHeaders] = useState([]);
  const [regularHeaders, setRegularHeaders] = useState([]);
  const [tableDatas, setTableDatas] = useState();

  const [PredictedRWM, PasspredictedReading, PasspredictedWriting, PasspredictedMaths, Notpredicted, NotpredictedReading, NotpredictedWriting, NotpredictedMaths, NotpredictedANY] = BigPicture.ProgressMainTableOutputKeys;

  const styles={
    tdStyles:{
      display: "flex",
      alignItems: "center",
      justifyContent:"space-evenly",
    },
    tdStylesNotPredicted:{
      display: "flex",
      alignItems: "center",
      paddingLeft: "10px",
    }
  }

  const renderCustomHeader = (year) =>{
    let output="";
    switch (Object.keys(year)[0]) {
    case "year1":case "year2":case "year3":case "year4":case "year5":case "year6":
      output=`${Object.keys(year)[0].charAt(0).toUpperCase()}${Object.keys(year)[0].charAt(Object.keys(year)[0].length-1)} (${Object.values(year)[0]?.classTotal})`
      break;
    
    default: output=`${Object.keys(year)} (${Object.values(year)[0]?.classTotal})`
      break;
    }
    return output;
  }

  // Formatting input data to fit the table structure
  const formatDetails = () => {
    const pupils = [];

    // Setting fixed headers and values for each pupil
    const headers = [BigPicture.ProgressOutputKeys.KeyInsightsAllPupils, Common.All, ...subject.predicted.map((year) => Object.keys(year))].flat();
    const headersSample = [BigPicture.ProgressOutputKeys.KeyInsightsAllPupils, `${Common.All} (${subject?.all?.classTotal})`, ...subject.predicted.map((year) => renderCustomHeader(year))].flat();
    setFixedHeaders(headersSample.slice(0, 1));
    setRegularHeaders(headersSample.slice(1));

    // Add rows with corresponding values to the result
    BigPicture.ProgressMainTableInputKeys.forEach((row, i) => {
      const eachRow = [row];

      headers.slice(1).forEach((header, j) => {
        const columns = {
          percent: "",
          value: "",
          student: []
        };

        if (j === 0) {
          // Include subject.all values for each column in the "All" row
          columns.percent = subject.all[row]?.passPercent;
          columns.value = subject.all[row]?.count;
          columns.student = subject.all[row]?.students;
        } else {
          // Find the corresponding year data for each column
          const yearData = subject.predicted.find(entry => entry[header]);
          columns.percent = yearData ? yearData[header][row]?.passPercent : "";
          columns.value = yearData ? yearData[header][row]?.count : "";
          columns.student = yearData ? yearData[header][row]?.students : [];
        }

        eachRow.push(columns);
      });

      // Add one more empty array with the same length when i is 4 because of Not predicted to pass: in UI which is there at 5th place
      if (i === 4) {
        pupils.push(Array(eachRow.length).fill(""));
      }

      pupils.push(eachRow);
    });
    setTableDatas(pupils)
  };


  const addTd = (arr) => {
    return arr.map((e, index) => <td key={index}>{e.toUpperCase()}</td>);
  };

  const renderFrozen = () => {
    return (
      <tbody>
        <tr><td style={styles.tdStyles}>{PredictedRWM} <div><img src={ClassHomeReadingCheckBox} alt="" /> <img src={ClassHomeWritingCheckBox} alt="" /> <img src={ClassHomeMathsCheckBox} alt="" /></div></td></tr>
        <tr><td style={styles.tdStyles}><img src={GroupSubList} alt="" /> {PasspredictedReading} <img src={ClassHomeReadingCheckBox} alt="" /></td></tr>
        <tr><td style={styles.tdStyles}><img src={GroupSubList} alt="" /> {PasspredictedWriting} <img src={ClassHomeWritingCheckBox} alt="" /></td></tr>
        <tr><td style={styles.tdStyles}><img src={GroupSubList} alt="" /> {PasspredictedMaths} <img src={ClassHomeMathsCheckBox} alt="" /></td></tr>
        <tr><td style={styles.tdStylesNotPredicted}>{Notpredicted}</td></tr>
        <tr><td style={styles.tdStyles}><img src={GroupSubList} alt="" /> {NotpredictedReading} <img src={NPReading} alt="" /></td></tr>
        <tr><td style={styles.tdStyles}><img src={GroupSubList} alt="" /> {NotpredictedWriting} <img src={NPWriting} alt="" /></td></tr>
        <tr><td style={styles.tdStyles}><img src={GroupSubList} alt="" /> {NotpredictedMaths} <img src={NPMaths} alt="" /></td></tr>
        <tr><td style={styles.tdStyles}><img src={GroupSubList} alt="" /> {NotpredictedANY} <div><img src={NPReading} alt="" /> <img src={NPWriting} alt="" /> <img src={NPMaths} alt="" /></div> </td></tr>
      </tbody>
    )
  };

  const renderRegularTd = (arr, rowIndex, columnHeader) => {
    const sliceArr = arr.slice(fixedHeaders.length);
    return sliceArr.map((e, index) => {
      if (rowIndex === 4) {
        return <td key={index}></td>;
      } else {
        return (
          <td key={index} onClick={() => callNextFun(e.student, rowIndex, columnHeader[index])}>{`${e.percent} (${e.value})`}</td>
        );
      }
    });
  };

  const renderRegular = (arr) => {
    return arr.map((e, index) => (
      <tr key={index}>{renderRegularTd(e, index, regularHeaders)}</tr>
    ));
  };

  const callNextFun = (e, rowIndex, selectedColumnHeader) => {
    const selectedValue = BigPicture.ProgressMainTableOutputKeys[rowIndex]; // Get the value of the first column
    setStudentDetails({ e, selectedValue, selectedColumnHeader });
    listView(false);
  };

  useEffect(() => {
    formatDetails();
  }, []);

  return (
    <div className="ppr-container">
      <div>
        <table className="fixed">
          <thead>
            <tr>{addTd(fixedHeaders)}</tr>
          </thead>
          {renderFrozen()}
        </table>
      </div>
      <div className="scroll">
        <table className="scrollable">
          <thead>
            <tr>{addTd(regularHeaders)}</tr>
          </thead>
          <tbody>{tableDatas && renderRegular(tableDatas)}</tbody>
        </table>
      </div>
    </div>
  );
};

export { PPRMainTable };